import { useTheme } from "@mui/material";

import { FileImageErrored } from "@/components/file-image-errored/FileImageErrored";
import type { GenerationTileAction } from "@/components/Tiles/GenerationTile/types";
import { TileObjectTypeIndicator } from "@/components/ui-v2/Tiles/common/TileObjectTypeIndicator";
import {
  TileBase,
  TileBaseProps,
} from "@/components/ui-v2/Tiles/TileBase/TileBase";
import { ObjectType } from "@/types";

interface GenerationFailedTileProps extends TileBaseProps {
  objectType: ObjectType;
  inferenceId: string;
  dismissable?: boolean;
  errorMessage?: string;
  onAction?: (
    event: React.MouseEvent | React.SyntheticEvent,
    action: GenerationTileAction,
  ) => void;
}

export const GenerationFailedTile = (props: GenerationFailedTileProps) => {
  const {
    objectType,
    inferenceId,
    dismissable = true,
    errorMessage = "",
    isSelected = false,
    isSelectable = false,
    isFocused = false,
    onAction,
  } = props;
  const theme = useTheme();

  const handleTileBaseAction =
    (action: GenerationTileAction) => (e: React.MouseEvent) => {
      onAction?.(e, action);
    };

  return (
    <TileBase
      isSelected={isSelected}
      isSelectable={isSelectable}
      data-testid="object-error"
      sx={{ background: theme.palette.secondary[6] }}
      isFocused={isFocused}
      slots={{
        topLeftEl: TileObjectTypeIndicator,
      }}
      slotProps={{
        topLeftEl: {
          objectType,
        },
      }}
      onClick={handleTileBaseAction("SELECT")}
    >
      <FileImageErrored
        inferenceId={inferenceId}
        dismissable={dismissable}
        errorMessage={errorMessage}
      />
    </TileBase>
  );
};
